import {
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Paper,
	Typography
} from '@mui/material';
import { useTheme } from '@mui/material/styles';

export type SimpleTableColumn<T> = {
	key: keyof T;
	label: string;
	align?: 'left' | 'right' | 'center';
};

export type SimpleTableProps<T> = {
	columns: SimpleTableColumn<T>[];
	data: T[];
	title?: string;
};

export function SimpleTable<T extends object>({ columns, data, title }: SimpleTableProps<T>) {
	const theme = useTheme();

	return (
		<TableContainer
			component={Paper}
			sx={{
				overflowX: 'auto',
				borderRadius: 0,
			}}
		>
			{title && (
				<Typography
					variant="body1"
					component="div"
					bgcolor={(theme) => theme.palette.background.default}
					borderTop="1px solid"
					borderColor={theme.palette.divider}
					sx={{
						pl: 1,
						pb: 1,
						pt: 1,
						fontWeight: 'bold' ,
						color: (theme) => theme.palette.brand.secondary
				}}>
					{title}
				</Typography>
			)}
			<Table size="small">
				<TableHead>
					<TableRow sx={{ borderBottom: '2px solid', borderColor: (theme) => theme.palette.brand.primary }}>
						{columns.map((col) => (
							<TableCell key={String(col.key)} align={col.align ?? 'left'} sx={{ fontWeight: 'bold', paddingLeft: .5 }}>
								{col.label}
							</TableCell>
						))}
					</TableRow>
				</TableHead>
				<TableBody>
					{data.map((row, idx) => (
						<TableRow key={idx}>
							{columns.map((col) => (
								<TableCell key={String(col.key)} align={col.align ?? 'left'} sx={{ paddingLeft: .5 }}>
									{String(row[col.key])}
								</TableCell>
							))}
						</TableRow>
					))}
				</TableBody>
			</Table>
		</TableContainer>
	);
}